import { useLingui } from "@lingui/react";
import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useInfiniteQuery } from "react-query";
import { UseInfiniteQueryOptions } from "react-query/types/react/types";

type Params = Parameters<typeof ApiSmpArtGallery.Polotno.stickers>[0];
type Response = Await<ReturnType<typeof ApiSmpArtGallery.Polotno.stickers>>;

const KEY_POLOTNO_STICKERS = "polotno.stickers";

export const useQueryPolotnoStickers = (
  params?: Params,
  options?: Omit<UseInfiniteQueryOptions<Response>, "queryKey" | "queryFn" | "getNextPageParam">,
) => {
  const {
    i18n: { locale },
  } = useLingui();

  params = {
    ...params,
    text_lang: locale,
  };

  return useInfiniteQuery<Response>(
    [KEY_POLOTNO_STICKERS, params],
    ({ pageParam }) => ApiSmpArtGallery.Polotno.stickers(pageParam || params),
    {
      ...options,
      getNextPageParam: (response) =>
        response.next ? Object.fromEntries(new URL(response.next).searchParams) : undefined,
    },
  );
};

useQueryPolotnoStickers.INITIAL_PARAMS = {
  tags__slug__all: [],
  ordering: "-created_at",
  page_size: 100,
  text_lang: "ru",
} satisfies Params;

useQueryPolotnoStickers.KEY = KEY_POLOTNO_STICKERS;
